export default __webpack_public_path__ + "static/media/215.9a2a49fc.jpg";